import { Link, useParams } from 'react-router-dom';
import { PageHeader } from '@/components/composites/PageHeader';
import { SectionCard } from '@/components/composites/SectionCard';
import { Button } from '@/components/primitives/Button';
import { ConditionBadge } from '@/components/primitives/ConditionBadge';
import { EmptyState } from '@/components/primitives/EmptyState';
import { StatusDot } from '@/components/primitives/StatusDot';
import { useRules } from '@/hooks/useRules';
import { useProjects } from '@/hooks/useProjects';
import styles from './ViewRulePage.module.css';

export function ViewRulePage() {
  const { ruleId } = useParams<{ ruleId: string }>();
  const { data: rules } = useRules();
  const { data: projects } = useProjects();
  const rule = rules.find((r) => r.id === ruleId);

  if (!rule) {
    return (
      <>
        <PageHeader title="Rule not found" />
        <EmptyState
          title="Rule not found"
          description="This rule does not exist in the current mockup tenant."
        />
      </>
    );
  }

  const project = projects.find((p) => p.id === rule.projectId);

  return (
    <>
      <PageHeader title={rule.name} />
      <SectionCard title="Rule details">
        <dl className={styles.metaGrid}>
          <dt className={styles.metaLabel}>Priority</dt>
          <dd className={`${styles.metaValue} ${styles.priorityValue}`}>#{rule.priority}</dd>
          <dt className={styles.metaLabel}>Project</dt>
          <dd className={styles.metaValue}>{project?.name ?? <>&mdash;</>}</dd>
          <dt className={styles.metaLabel}>Status</dt>
          <dd className={styles.metaValue}>
            <StatusDot tone={rule.status === 'enabled' ? 'enabled' : 'disabled'} />{' '}
            {rule.status === 'enabled' ? 'Enabled' : 'Disabled'}
          </dd>
        </dl>
      </SectionCard>
      <SectionCard title="Match conditions">
        <div className={styles.conditionsList}>
          {rule.conditions.map((c, i) => (
            <ConditionBadge
              key={`${rule.id}-cond-${i}`}
              type={c.type}
              operator={c.operator}
              value={c.value}
            />
          ))}
        </div>
      </SectionCard>
      <div className={styles.backButton}>
        <Link to="/rules">
          <Button variant="secondary">Back to Rules</Button>
        </Link>
      </div>
    </>
  );
}
